<template>
  <div>
    <div class="stepper d-none d-lg-block">
      <div
        v-for="e in steps"
        :key="e.step"
        :class="'step ' + e.status"
        :id="e.step"
        v-on:click="move(e.step)"
      >
        <div class="circle"></div>
        <div class="content">{{ e.message }}</div>
      </div>
      <div class="step pb-0">
        <div class="circle"></div>
      </div>
    </div>

    <div class="mb-4 d-lg-none">
      <div class="d-flex flex-wrap">
      <b-btn
        variant="link"
        v-on:click="move(steps[step - 2].step)"
        rounded="lg"
        class="text-dark font-weight-bolder p-1"
        v-if="step > 1"
      >
        <font-awesome-icon
          :icon="['fad', 'angle-left']"
          size="lg"
          class="mr-1"
        />
        {{ steps[step - 2].message }}
      </b-btn>
      <b-btn
        variant="link"
        disabled
        v-on:click="move(steps[step - 2].step)"
        rounded="lg"
        class="text-dark font-weight-bolder ml-auto p-1 d-none d-sm-inline-block"
        v-if="step < steps.length"
      >
        Suivant : {{ steps[step].message }}
      </b-btn>
      </div>
      <b-progress :value="step - 1" :max="steps.length" variant="secondary" height="10px"></b-progress>
    </div>
  </div>
</template>

<script>

export default {
  name: "Stepper",
  props: {
    step: Number,
    office: String,
    name: String,
    date: String,
    appointmentType: String,
    displayOfficeChoice: Boolean
  },

  data() {
    return {
      actionList: this.$root.slugData.actions,
      steps: [
        {
          step: 1,
          message: "Sélectionner le type d'entretien",
          status: null,
        },
        {
          step: 2,
          message: "Choix de l'agence",
          status: null,
        },
        {
          step: 3,
          message: "Compléter ses informations",
          status: null,
        },
        {
          step: 4,
          message: "Planifier l'entretien",
          status: null,
        },
        {
          step: 5,
          message: "Récapitulatif",
          status: null,
        },
      ],
      refSteps: null,
    };
  },

  watch: {
    step: function (val) {
      for (let i = 0; i < val; i++) {
        switch (i) {
          case 1:
            this.steps[0].message = this.getAppointmentName();
            break;
          case 2:
            if (this.displayOfficeChoice)
              this.steps[1].message = this.office;
            else if(this.name !== "null null") this.steps[1].message = this.name;
            break;
          case 3:
            if (this.displayOfficeChoice && this.name !== "null null")
              this.steps[2].message = this.name;
            else this.steps[2].message = this.date;
            break;
          case 4:
            if (this.displayOfficeChoice)
              this.steps[3].message = this.date;
            break;
        }
        this.steps[i].status = "completed";
      }
      this.steps[val - 1].status = "current";
    },
  },

  mounted() {
    this.steps[0].status = "current";
    if (!this.displayOfficeChoice) {
      this.steps.splice(1, 1);
      this.steps[1].step = 2;
      this.steps[2].step = 3;
      this.steps[3].step = 4;
    }
  },

  methods: {
    move(step) {
      if (step < this.step) {
        this.$emit("update", step);
      }
    },
    getAppointmentName() {
      for (let i = 0; i < this.actionList.length; i++)
        if (this.actionList[i].value === this.appointmentType)
          return this.actionList[i].text;
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper {
  display: flex;
  flex-direction: column;
  padding: 0 1.75rem 0 1rem;
}

/* regular step */
.step .circle {
  margin-left: auto;
  background-color: rgb(6, 150, 215);
  border: 3px solid white;
  border-radius: 100%;
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  left: 0.9rem;
}

.step {
  border-right: 0.2rem solid rgb(212, 212, 212);
  color: rgb(114, 114, 114);
}

.step.completed .circle,
.step.current .circle {
  background-color: rgb(6, 150, 215);
  border-color: rgb(6, 150, 215);
}

.content {
  padding: 0.6rem 0;
  margin-right: 1rem;
  font-weight: 500;
  text-align: right;
}

.step.completed .content,
.step.current .content {
  color: rgb(26, 26, 26);
}

.step.current .content {
  font-weight: 700;
  font-size: 1.05em;
}

.step.completed .content:hover,
.step.completed .content:focus {
  text-decoration: underline;
  cursor: pointer;
}
</style>
